module.exports = __webpack_public_path__ + "src/assets/img/cmd-clear-immo.e085083c.svg";